<div class="row">
    <div class="col-sm-8 col-sm-offset-2">
        <h2>Connexion</h2>
        <form [formGroup]='signInForm' (ngSubmit)='onSubmit()'>
            <div class="form-group">
                <label for="email">Email</label>
                <input type="text" id="email" class="form-control" formControlName='email'>
            </div>
            <div class="form-group">
                <label for="password">Mot de passe</label>
                <input type="password" id="password" class="form-control" formControlName="password">
            </div>
            <button class="btn btn-primary" type="submit" [disabled]='signInForm.invalid'>Se connecter</button>
        </form>
        <a (click)='onNewPassword()' style="cursor:pointer; color: blue; text-underline-position: auto;">Mot de passe oublié ?</a>
        <re-captcha
                *ngIf="captcha"
                (resolved)="resolved($event)"
                siteKey="6LdeGXAaAAAAAI3Z4xiilP7M4KrfrT4iqRdCVgx-"
        ></re-captcha>
        <p class="text-danger">{{errorMessage}}</p>
    </div>
</div>